// removed by extract-text-webpack-plugin
module.exports = {"popupBox":"_1jzqXIX1UaRhUmfg_7wT0i","popupBoxInner":"_1TS102kLnQ18Y59IJ1Mpy_","epicSubscription":"_1AShWxYhcL5pbuAqfQxJLm","preloaderWrap":"_2ziF57JIvXylXf1xdxotXU","noUnrealLicense":"_3pKznIgqRoLmlChSmutkOG","footer":"K6ei7iOM_NXq8vL_a1Sgg","header":"_1SU_1l7NRE4_4HeO73a9cG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/styles.scss
// module id = 2859
// module chunks = 0